import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { RemoteActionService } from '../../remote-action/logic/remote-action.service';
import { RemoteAction } from 'src/app/_model/remote-action/remote-action';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '../../alert/alert.service';
import { IMSAction } from 'src/app/_model/menu';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { LoadingService } from '../../loading/loading.service';

export const ExportLogAction: IMSAction = {
  type: 'action',
  target: 'clear_log',
};

@Injectable({
  providedIn: 'root',
})
export class ClearLogActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'clear_log';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private alertService: AlertService,
    private remoteActionService: RemoteActionService,
    private appParameters: AppParameterService,
    private loadingService: LoadingService,
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    await this.logger.clearLogs();
  }

  // Private Functions
}
